export default __webpack_public_path__ + "static/media/character_06.9be00102.png";